<template>
<div>

  <ul class="pro-flex-list">
    <li
      class="pro"
      v-for="(item) in list"
      :key="item.goods_id"
    >
      <template v-if="item.image_url">
        <router-link tag="a" target="_blank" :to="{name:detailname,params: {id: item.goods_id, groupid:item.id}}">
          <div class="pro-img">
            <img v-lazy="item.image_url" alt :key="item.image_url">
          </div>
          <div class="title">{{item.goods_name}}</div>
          <div class="price-wrap">
            <div class="price">{{$t('currencySymbol')}}{{item.goods.price||'0.00'}}</div>
          </div>
					<div>
						<span style="color: #666;">还剩</span>
						<el-statistic style="width: auto;display: inline-block;" format="DD天 HH:mm:ss" :value="new Date(item.etime)" time-indices></el-statistic>
					</div>
        </router-link>
       <div class="add-wrap">
         <router-link  class="info-img" :to="{name:detailname,params: {id: item.goods_id, groupid:item.id}}"></router-link>
       </div>
      </template>
    </li>
  </ul>
</div>
  
</template>
<script>
export default {
  name: "Grouplist",
  components: {},
  props: {
		detailname: {
			type: String,
			default: 'groupdetail'
		},
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";

.drawer-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.5);
  visibility: hidden;
  -webkit-transition: opacity .3s 0s, visibility 0s .3s;
  transition: opacity .3s 0s, visibility 0s .3s;
  &.show {
    opacity: 1;
    visibility: visible;
    transition: opacity .3s 0s, visibility 0s 0s;
    .drawer-content{
      transform: translateY(0);
    }
  }
  .submit {
    width: 100%;
    background-color: #ff5722;
    border-color: #ff5722;
    border-width: 1px;
    font-size: 18px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    color: #fff;
    cursor: pointer;
  }
}

.drawer-content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgb(255,255,255);
  box-shadow: 0 0 20px rgba(0,0,0,.2);
  transform: translateY(110%);
  transition-property: transform;
  transition-duration: 0.3s;
  .att-popup-header {
    display: inline-block;
    position: relative;
    padding: 0.3rem 0.3rem 0.3rem 5rem;
    width: 100%;
    border-top: 1px solid rgb(229,229,229);
    border-bottom: 1px solid rgb(229,229,229);
    margin-bottom: 10px;
    float: left;
    .thumb {
      position: absolute;
      width: 40px;
      height: 40px;
      top: -12px;
      left: 10px;
      margin-right: 10px;
      background-color: rgb(255,255,255);
      border: 1px solid rgb(221,221,221);
      border-radius: 3px;
    }
    .info {
      color:  #585858;
      div {
        margin-bottom: 10px;
      }
    }
  }
}
.add-wrap {
  position: absolute;
  bottom: 14px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  .info-img {
    background-position: -92px -71px;
    width: 46px !important;
    height: 46px !important;
    // position: absolute;
    background-image: url('~@/assets/images/video/video-pic.png');
    background-repeat: no-repeat;
    display: inline-block;
  }
  .add-cart {
    background: #de4d1e;
    width: 82px;
    height: 25px;
    border-radius: 3px;
    text-align: center;
    line-height: 25px;
    color: #ffffff;
    font-size: 14px ;
    margin-top: 10px;
    // position: absolute;
  }
}
.pro-flex-list {
  display: flex;
  flex-flow: row wrap;
  background: #fff;
  // justify-content: space-between;
  .pro {
    padding: 11px;
    width: 355px;
    height: 490px;
    margin: 15px;
    background: #fff;
    border: 1px solid #e5e5e5;
    transition: all 0.2s linear 0s;
    box-shadow: 2px 2px 4px #e3e3e3;
    position: relative;
    &:nth-child(3n - 2) {
      // margin-left: 0;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      box-shadow: 0 15px 20px rgba(0,0,0,0.1);
    }
    &.row-4 {
      width: 24%;
    }
    &.not {
      &.not {
        background: $theme-bg;
      }
    }
    &.active:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .pro-handle-icon {
        display: block;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      .pro-img {
        width: 355px;
        height: 355px;
        margin: 0 auto 10px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .title {
        font-size: 14px;
        height: 42px;
        // line-height: 42px;
        font-weight: 500;
        color:#666;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-top: 10px;
        margin-bottom: 5px;
      }
      .desc {
        height: 18px;
        font-size: 12px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #b0b0b0;
      }
      .price-wrap {
        padding: 10px 0;
        .price {
          color: #de4d1e;
          font-size: 28px;
          font-weight: normal;
        }
      }
      
    }
  }
}
//产品收藏添加购物车
.pro-handle-icon {
  display: none;
  position: absolute;
  height: 24px;
  top: 14px;
  cursor: pointer;
  padding: 3px 4px;
  span {
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s linear;
    color: $theme-color;
  }
  &:hover {
    span {
      opacity: 1;
      font-weight: 550;
    }
    // .icon {
    //   color: $theme-color;
    // }
  }
  .icon {
    font-size: 18px;
    vertical-align: -1px;
    margin-right: 3px;
    color: $theme-color;
    // color:#FFF;
  }
  &.pro-collet-icon {
    left: 10px;
  }
  &.pro-addcart-icon {
    right: 10px;
  }
}


.tr-group {
          margin-bottom: 15px;
          position: relative;
          display: flex;
          width: 100%;       
          padding-left: 20px;
          border-bottom: 1px solid #e5e5e5;
          padding-bottom: 4px;
          &.underline {
            padding-bottom: 10px;
            border-bottom: 1px solid $border;
          }
          .tr-title-left {
            color: #838383;
            font-size: 12px;
            display: inline-block;
            min-width: 60px;
            padding-right: 10px;
            height: 32px;
            line-height: 32px;
          }
          .tr-right {
            display: inline-block;
            flex: 1;
            .discounts-login {
              font-size: 12px;
              cursor: pointer;
              span {
                color: #e7442f;
              }
            }
            .now-price {
              color: $theme-color;
              text-align: left;
              margin-right: 20px;
              i {
                font-size: 16px;
              }
              .price-num {
                font-size: 22px;
              }
            }
            .old-price {
              color: #666;
              font-size: 12px;
            }
            .cx-item {
              padding: 2px 4px;
              background: $theme-color;
              color: #fff;
              margin-right: 10px;
              font-size: 12px;
              height: 24px;
              line-height: 24px;
            }
            .color,
            .size {
              font-size: 12px;
              border: 1px solid #b8b7bd;
              margin-right: 8px;
              display: inline-block;
              height: 28px;
              line-height: 28px;
              margin-bottom: 12px;
              &.active {
                border-color: $theme-color;
                background: $theme-color;
                color: #fff;
              }
              a {
                display: block;
                padding: 0 10px;
              }
              &:hover {
                border: 1px solid $theme-color;
              }
            }
            .weight {
              font-size: 12px;
            }
            .kc {
              color: #878787;
              display: inline-block;
              font-size: 12px;
              margin-left: 20px;
            }
          }
        }

.color.diable {
  color: #ccc;
  border: 1px solid #ccc;
  cursor: not-allowed !important;
  a{
    cursor: not-allowed !important;
  }
  &:hover {
    border: 1px solid #ccc !important;
  }
}


.integral{
	span {
		color:#FF4444;
		border: 1px solid #FF4444;
		font-size: 14px;
		border-radius: 4px;
		padding: 0px 10px;
		margin-top: 4px;
	}
}
 ::v-deep .el-statistic .con {
	color: #de4d1e!important;
}
</style>